export enum InputEnum {
  Text,
  Number,
  Percentage,
  Currency,
  Date,
  YesNo,
  choice,
  multiChoice,
  peoplePickerSingle,
  peoplePickerMultiple,
  taxonomySingle,
  taxonomyDouble,
  datasourceText,
  datasourceDropdown,
  datasourceMultipleDropdown,
  lookupMulti,
  lookupSingle,
  datasourceTagPicker
}
